import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {CodeIcon, EyeIcon, GitPullRequestIcon, IssueOpenedIcon, LightBulbIcon, RocketIcon} from '@primer/octicons-react'

import styles from './SuggestionCard.module.css'

type SuggestionCardProps = {
  titleHtml: SafeHTMLString
  icon: string
  color: string
  onClick: () => void
}

// Icons referenced by the local `icebreakers.json` suggestions. Only these are
// imported so the whole @primer/octicons-react set is not bundled. Adding a new
// icon to `icebreakers.json` requires a matching entry here; the coverage test
// in `__tests__/SuggestionCard.browser.test.tsx` enforces it.
export const SUGGESTION_ICONS = {
  code: <CodeIcon />,
  eye: <EyeIcon />,
  'git-pull-request': <GitPullRequestIcon />,
  'issue-opened': <IssueOpenedIcon />,
  'light-bulb': <LightBulbIcon />,
  rocket: <RocketIcon />,
} as const

/** Names of the icons available to icebreaker suggestions. */
export type SuggestionIconName = keyof typeof SUGGESTION_ICONS

/** Get the `Icon` component for a kebab-case icon name. */
function getIcon(icon: string) {
  return SUGGESTION_ICONS[icon as SuggestionIconName]
}

export function SuggestionCard({titleHtml, icon, color, onClick}: SuggestionCardProps) {
  const iconElement = getIcon(icon)

  return (
    <button className={styles.suggestionButton} onClick={onClick}>
      {iconElement && (
        <div className={styles.icon} style={{color}}>
          {iconElement}
        </div>
      )}
      <VerifiedHTMLDiv html={titleHtml} />
    </button>
  )
}
